import React, { useState, useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import keycloak from './keycloak';
import Loader from 'components/common/Loader';

const PrivateRoute = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { setApisLoading } = useOutletContext();

  useEffect(() => {
    if (keycloak.authenticated) {
      setIsLoading(false);
    } else {
      keycloak.init().then(() => {
        setIsLoading(false);
      });
    }
  }, []);

  if (isLoading) {
    return <Loader />;
  }

  return <Outlet context={{ setApisLoading }} />;
};

export default PrivateRoute;
